import { Fragment, useContext, useRef, useState } from "react";
import classes from "./profile.module.css";
import ProfileForm from "./profileForm";
import { CartContext } from "../../../CartContext";
import { Link, useNavigate } from "react-router-dom";
import Modal from "../../Layout/Modal";

export default function Profile() {
  const [enteredInput, setEnteredInput] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [profile, setProfile] = useState([]);
  const cartCtx = useContext(CartContext);
  const [profileForm, setProfileForm] = useState(false);

  fetch(
    "https://identitytoolkit.googleapis.com/v1/accounts:lookup?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
    {
      method: "POST",
      body: JSON.stringify({
        idToken: cartCtx.token,
      }),
    }
  )
    .then((res) => {
      if (!res.ok) {
        return;
      }
      return res.json();
    })
    .then((data) => {
      setProfile(data.users);
    });
  const handleProfileForm = () => {
    setProfileForm((prevState) => {
      return !prevState;
    });
  };

  let validInput = false;

  function deleteInputHandler(e) {
    setEnteredInput(e.target.value);
  }

  function deleteAccountHandler(e) {
    e.preventDefault();
    if (enteredInput !== "DELETE") {
      validInput = false;
      return;
    }

    validInput = true;

    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:delete?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: cartCtx.token,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          alert("Problem deleting account...Try later");
        }
        return res.json();
      })
      .then((data) => {
        alert("Account Deletion Successful!");
        cartCtx.logout();
      });
  }

  return (
    <Fragment>
      <div className={classes.body}>
        {profileForm && <ProfileForm setProfileForm={setProfileForm} />}

        {profile.map((user) => (
          <Fragment>
            <div className={classes.header}>
              <i
                onClick={() => {
                  navigate("/profile", { replace: true });
                }}
                class="fa-solid fa-arrow-left"
              ></i>
              <h1>Profile Details</h1>
              <button onClick={handleProfileForm}>Edit Profile</button>
            </div>
            <div key={user.localId} className={classes.container}>
              <div className={classes.details}>
                <div id="display" className={classes.picture}>
                  <img alt="profile" src={user.photoUrl} />
                </div>
                <div className={classes.name}>
                  <p>Wish you a happy shopping experience!</p>
                  <p>DC Luxury</p>
                </div>
              </div>

              <div className={classes.bio}>
                <div className={classes.email}>
                  <p>Email</p>
                  <hr />
                  <p>{user.email}</p>
                </div>
                <div className={classes.email}>
                  <p>Profile ID</p>
                  <hr />
                  <p>{user.localId}</p>
                </div>
                <hr />
                <div className={classes.logout}>
                  <p
                    onClick={() => {
                      cartCtx.logout();
                    }}
                  >
                    Sign Out
                  </p>
                  <i class="fa-solid fa-greater-than"></i>
                </div>
                <hr />
                <div className={classes.logout}>
                  <p onClick={() => setShowModal(true)}>Delete Account</p>
                  <i class="fa-solid fa-greater-than"></i>
                </div>
                {showModal && (
                  <Modal>
                    <div>
                      <form
                        onSubmit={deleteAccountHandler}
                        className={classes.delete}
                      >
                        <label>
                          Enter <span>DELETE</span> to confirm account deletion
                        </label>
                        <input
                          onChange={deleteInputHandler}
                          placeholder="enter DELETE"
                        />
                        <div className={classes.action}>
                          <button
                            onClick={() => setShowModal(false)}
                            className={classes.cancel}
                            type="button"
                          >
                            Cancel
                          </button>
                          <button className={classes.confirm}>Confirm</button>
                        </div>
                      </form>
                    </div>
                  </Modal>
                )}
              </div>
            </div>
          </Fragment>
        ))}
        <Link className={classes.link} to="/">
          Back to Home
        </Link>
      </div>
    </Fragment>
  );
}
